var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      ref: "sideContent",
      class: [_vm.$style.sideContent, _vm.getStyle],
      attrs: { column: "", "fill-height": "" }
    },
    [
      _c(
        "v-flex",
        { ref: "sideHeader", attrs: { shrink: "" } },
        [_vm._t("header")],
        2
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          class: _vm.$style.sideMain,
          style: { maxHeight: _vm.height },
          attrs: { grow: "" }
        },
        [_vm._t("main")],
        2
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { ref: "sideFooter", attrs: { shrink: "" } },
        [_vm._t("footer")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/layouts/SideContent.vue?vue&type=template&id=9f72779a&
// module id = null
// module chunks = 